module.exports = "<app-loader></app-loader>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n"